import { FullChoiceProgramReviewScreen } from '@/components/FullChoiceProgramReviewScreen';

export default function FullChoiceProgramReview() {
  return <FullChoiceProgramReviewScreen />;
}
